export default {
  color: '#eee',
};
